package com.macrofocus.eflux.network.physical

fun String.left6() : String = substring(0..5)

fun String.left7() : String = if(length > 7) substring(0..6) else this